import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const HomeIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M7.99996 1.33325C7.9118 1.33326 7.82451 1.35076 7.74315 1.38473C7.6618 1.41871 7.58799 1.46848 7.526 1.53117L0.802043 7.39836C0.760049 7.42934 0.725917 7.46976 0.702397 7.51635C0.678876 7.56294 0.666624 7.6144 0.666626 7.66659C0.666626 7.75499 0.701745 7.83978 0.764257 7.90229C0.826769 7.9648 0.911554 7.99992 0.999959 7.99992H2.66663V13.3333C2.66663 13.7013 2.96529 13.9999 3.33329 13.9999H5.99996C6.36796 13.9999 6.66663 13.7013 6.66663 13.3333V9.33325H9.33329V13.3333C9.33329 13.7013 9.63196 13.9999 9.99996 13.9999H12.6666C13.0346 13.9999 13.3333 13.7013 13.3333 13.3333V7.99992H15C15.0884 7.99992 15.1732 7.9648 15.2357 7.90229C15.2982 7.83978 15.3333 7.75499 15.3333 7.66659C15.3333 7.6144 15.321 7.56294 15.2975 7.51635C15.274 7.46976 15.2399 7.42934 15.1979 7.39836L8.47782 1.53507C8.47653 1.53377 8.47523 1.53247 8.47392 1.53117C8.41193 1.46848 8.33812 1.41871 8.25676 1.38473C8.17541 1.35076 8.08812 1.33326 7.99996 1.33325Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

HomeIcon.propTypes = {
  sx: PropTypes.object,
};

export default HomeIcon;
